/** Küçük biçimlendirme yardımcıları (sunucudan gelen ham değerler için). */

/** Süreyi `1:02:03` / `12:34` biçimine çevirir. Geçersiz veya bilinmeyen → `—`. */
export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms) || ms < 0) return '—';
  const totalSeconds = Math.round(ms / 1000);
  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);
  const pad = (n: number) => String(n).padStart(2, '0');
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
}

/** Toplam kütüphane süresini `12 sa 34 dk` veya `45 dk` biçimine çevirir. */
export function formatTotalDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms) || ms <= 0) return '—';
  const totalMinutes = Math.round(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0 && minutes > 0) return `${hours} sa ${minutes} dk`;
  if (hours > 0) return `${hours} sa`;
  return `${minutes} dk`;
}

/**
 * Tarih biçimlendirmesi — tek kaynak (D-12).
 *
 * Önceden ana sayfa `21.10.2026`, kütüphane ekranı `21 Eki 2026` üretiyordu:
 * aynı veri, aynı üründe iki farklı biçim. Tüm ekranlar bu iki yardımcıdan
 * beslenir; bileşenlerde `toLocaleDateString` çağrısı kalmaz.
 */
export function formatDate(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '—';
  return new Date(ms).toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/** Tarih + saat: `21 Eki 2026, 11:22`. Geçersiz → `—`. */
export function formatDateTime(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '—';
  return new Date(ms).toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Bir öğenin gösterilecek başlığı (sezon/bölüm numarasıyla birlikte). */
export function displayTitle(item: {
  kind: string;
  title: string;
  year?: number | null;
  seasonNumber?: number | null;
  episodeNumber?: number | null;
}): string {
  if (item.kind === 'episode') {
    const season = item.seasonNumber ?? 1;
    const episode = item.episodeNumber ?? 1;
    return `S${String(season).padStart(2, '0')}E${String(episode).padStart(2, '0')} · ${item.title}`;
  }
  if (item.kind === 'season') return `${item.title} · Sezon ${item.seasonNumber ?? 1}`;
  // `undefined` de "yıl yok" demektir; sunucu `null` gönderebilir, istemci
  // alanı hiç taşımayabilir. İkisi de parantezsiz başlık üretmeli.
  return item.year == null ? item.title : `${item.title} (${item.year})`;
}

/** Kart üzerindeki ilerleme çubuğu için 0–1 oran. */
export function progressRatio(positionMs: number | undefined, durationMs: number | null): number {
  if (!positionMs || !durationMs || durationMs <= 0) return 0;
  return Math.min(1, positionMs / durationMs);
}
